import { useState, useEffect } from 'react';
import './Dashboard.css';

interface DashboardStats {
  totalArticles: number;
  totalUsers: number;
  recentArticles: Array<{
    id: number;
    title: string;
    createdAt: string;
  }>;
}

export function Dashboard() {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch('/api/admin/stats', {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (!response.ok) {
          throw new Error('Erro ao carregar estatísticas');
        }

        const data = await response.json();
        setStats(data);
      } catch (error) {
        setError(error instanceof Error ? error.message : 'Erro ao carregar dados');
      } finally {
        setIsLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (isLoading) {
    return <div className="loading">Carregando...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (!stats) {
    return null;
  }

  return (
    <div className="dashboard">
      <h1>Dashboard</h1>

      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total de Artigos</h3>
          <p className="stat-number">{stats.totalArticles}</p>
        </div>

        <div className="stat-card">
          <h3>Total de Usuários</h3>
          <p className="stat-number">{stats.totalUsers}</p>
        </div>
      </div>

      <div className="recent-articles">
        <h2>Artigos Recentes</h2>
        <div className="articles-list">
          {stats.recentArticles.map(article => (
            <div key={article.id} className="article-item">
              <h4>{article.title}</h4>
              <p>Adicionado em: {new Date(article.createdAt).toLocaleDateString()}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
} 